export const invoicesRoutes = {
  invoices: () => '/invoices',
  setInvoiceStatus: (id: string) => `/invoices/${id}/status`,
  downloadInvoice: (id: string) => `/invoices/${id}/export`,
  exportInvoices: () => '/invoices/export',
  resendInvoiceById: (invoiceId: string) => `/invoices/${invoiceId}/resend`,
};
